import { FormFields } from '@/components/Form/types';

import { BUY_SELL_OPTIONS } from '../TradeNotification/constants';

import { FXHeatmapFormValues } from './components/FXHeatmap/types';

export const defaultValuesFXHeatmap: FXHeatmapFormValues = {
  curveDate: '',
  tenors: '0.25,1,3',
  histories: '1,2.5,5',
  pairCurrency: [
    {
      left_buysell: { value: BUY_SELL_OPTIONS[1].value, label: 'Sell' },
      left_currency: { label: 'USD', value: '1' },
      right_buysell: { value: BUY_SELL_OPTIONS[0].value, label: 'Buy' },
      right_currency: { label: 'CAD', value: '7' },
    } as FormFields,
  ],
};
